import { useQuery } from '@tanstack/react-query';
import { settingApi } from '../api/settingApi';
import type { SettingSearchParams } from '../types/setting';

/**
 * GET /api/eraf/system-settings — settings grouped by category
 * queryKey: ['system-settings', 'list', params]
 */
export function useSettings(params?: SettingSearchParams) {
  return useQuery({
    queryKey: ['system-settings', 'list', params ?? {}],
    queryFn: () => settingApi.listByCategory(params),
    staleTime: 30_000,
  });
}
